import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_KEY = 'board/:boardId/reporting/stages/:stageId/owners';

export function useOpportunityReportingStageOwnersQuery({
	boardId,
	filterRequest,
	stageId,
	enabled,
}: {
	boardId: string;
	filterRequest: Api.IOpportunityReportingFilterRequest;
	stageId: string;
	enabled: boolean;
}) {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		meta: {
			toastErrorMessage: 'Failed to load stage owners',
		},
		queryFn: () =>
			userSession.webServiceHelper.callAsync<Api.IOpportunityReportingStageOwnersResponse>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `board/${boardId}/reporting/stages/${stageId}/owners`,
				}),
				'POST',
				filterRequest
			),
		queryKey: [BASE_KEY, boardId, filterRequest, stageId],
		refetchOnWindowFocus: false,
	});
}
